import { LocalDate } from '@js-joda/core';

import { useBoolean } from '@dreryk/react-common';

import { InvoiceCreateFormController } from '../form/InvoiceCreateForm.types';
import { InvoicePaymentMethod } from '../../types';

import { WithReceiptModal } from './WithReceiptModal';

type WithReceiptModalOpenerRenderProps = {
   openModal: VoidFunction;
};
type WithReceiptModalOpenerProps = Pick<InvoiceCreateFormController, 'handleSubmit'> & {
   readonly children: (renderProps: WithReceiptModalOpenerRenderProps) => JSX.Element | null;
   readonly onClose: VoidFunction;
   readonly paymentMethod: InvoicePaymentMethod;
   readonly visitDate: LocalDate;
   readonly visitSettlementId: number;
};

export const WithReceiptModalOpener = (props: WithReceiptModalOpenerProps): JSX.Element => {
   const { handleSubmit, onClose, paymentMethod, visitDate, visitSettlementId } = props;
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleSuccess = (): void => {
      closeModal();
      onClose();
   };

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <WithReceiptModal
               onClose={closeModal}
               onSuccess={handleSuccess}
               handleSubmit={handleSubmit}
               paymentMethod={paymentMethod}
               visitDate={visitDate}
               visitSettlementId={visitSettlementId}
            />
         ) : null}
      </>
   );
};
